import { create } from "zustand";
import axiosInstance from "../../api/axiosInstance";

interface Field {
  type: string;
  value: string;
  link?: string;
}

interface Testimonial {
  title: string;
  description: string;
  image: string;
}

interface Section {
  id: number;
  section_name: string;
  payload: Record<string, Field>;
  loop_fields: Testimonial[];
  loaded?: boolean;
}

interface HomeState {
  sections: Record<string, Section>;
  fetchSectionsList: () => Promise<void>;
  fetchSectionContent: (sectionName: string) => Promise<void>;
}

const useHomeStore = create<HomeState>((set, get) => ({
  sections: {},

  // Step 1: Fetch the list of sections (without payloads)
  fetchSectionsList: async () => {
    try {
      const response = await axiosInstance.get("/cmsPages/home/sections");
      const sectionsList = response.data.rows; // Assuming this is an array of sections

      // Initialize sections with empty data
     const formattedSections= sectionsList.reduce(
        (acc: Record<string, Section>, section: any) => {
          acc[section.section_name] = {
            id: section.id,
            section_name: section.section_name,
            payload: {}, // Empty initially
            loop_fields: [], // Empty initially
            
          };
          return acc;
        },
        {}
      );
      console.log(formattedSections);
       set({ sections: formattedSections });

      // Step 2: Fetch each section's content individually
      sectionsList.forEach((section:any) => {
        get().fetchSectionContent(section.section_name);
      });
    } catch (error) {
      console.error("Error fetching sections list:", error);
    }
  },

  // Step 3: Fetch content for a single section
  fetchSectionContent: async (sectionName: string) => {
    try {
      console.log(`⏳ Fetching content for: ${sectionName}`);
      const response = await axiosInstance.get(`/cmsPages/home/section/${sectionName}`);
      const sectionData = response.data;

      if (sectionData) {
        const parsedPayload = JSON.parse(sectionData.payload || "{}");
        const parsedLoopFields = JSON.parse(sectionData.loop_fields || "[]");
        console.log('dddddd',sectionData);
        set((prev) => ({
          sections: {
            ...prev.sections,
            [sectionName]: {
              ...prev.sections[sectionName],
              payload: parsedPayload,
              loop_fields: parsedLoopFields,
              loaded: true, 
            },
          },
        }));
       
      }
    } catch (error) {
      console.error(`Error fetching content for section: ${sectionName}`, error);
    }
  },
}));

export default useHomeStore;
